// @flow @format
import React, {PureComponent, type Node} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import './Popover.css';

class ContextProxy extends PureComponent<{
	cx: Object,
	children?: Node,
}> {
	static childContextTypes = {
		router: PropTypes.object,
		store: PropTypes.object.isRequired,
	};

	static propTypes = {
		cx: PropTypes.object.isRequired,
		children: PropTypes.element.isRequired,
	};

	getChildContext() {
		return this.props.cx;
	}

	render() {
		return this.props.children;
	}
}

export const POPOVER_ID = 'popover-wrapper';

type Props = {
	children?: Node,
};

class Popover extends PureComponent<Props> {
	_popoverWrapper: HTMLElement;
	_popoverLayer: HTMLElement;

	static contextTypes = {
		store: PropTypes.object.isRequired,
		router: PropTypes.object.isRequired,
	};

	static propTypes = {
		children: PropTypes.node,
	};

	componentWillMount() {
		let popover = document.getElementById(POPOVER_ID);

		if (!popover) {
			this._popoverWrapper = document.createElement('div');
			this._popoverWrapper.id = POPOVER_ID;
			this._popoverWrapper.className = 'Popover';
			document.body && document.body.appendChild(this._popoverWrapper);
		} else {
			this._popoverWrapper = popover;
		}

		this._popoverLayer = document.createElement('div');
		this._popoverLayer.className = 'Popover__Layer';
		this._popoverWrapper.appendChild(this._popoverLayer);
	}

	componentDidMount() {
		ReactDOM.render(
			<ContextProxy cx={this.context}>
				{React.Children.only(this.props.children)}
			</ContextProxy>,
			this._popoverLayer
		);
	}

	componentWillUnmount() {
		ReactDOM.unmountComponentAtNode(this._popoverLayer);
		this._popoverWrapper.removeChild(this._popoverLayer);
	}

	componentWillUpdate(nextProps: Props) {
		ReactDOM.render(
			<ContextProxy cx={this.context}>
				{React.Children.only(nextProps.children)}
			</ContextProxy>,
			this._popoverLayer
		);
	}

	render() {
		return <div />;
	}
}

export default Popover;



// WEBPACK FOOTER //
// ./src/components/Popover/Popover.js